import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import "./Order_id_holder.css";
import { formatCustomDate } from "../../../../../../../utils/common";
import Cancel_Order_btn from "../../../../../../Common-Component/common_btn/cancel_Order_btn/Cancel_Order_btn";
import { Context } from "../../../../../../../utils/context";
// import Return_Lottie from "../../../Animation/return_Lottie/Return_Lottie";

function Order_id_holder({ order, headingText, subText }) {
  const location = useLocation();

  const { IMG_URL } = useContext(Context);
  const isReturnPage = location.pathname === "/return-order-details";

  const handleDownloadInvoice = async (invoicePath) => {
    if (!invoicePath) {
      alert("Invoice not available");
      return;
    }

    try {
      const fileUrl = `${IMG_URL}${invoicePath}`;

      console.log(fileUrl,"fileUrl fileUrl");
      
      // Fetch the file as blob
      const response = await fetch(fileUrl, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();

      // Create a temporary object URL from blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "GroscidoInvoice.pdf"); 
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download invoice");
    }
  };
  return (
    <>
      <section className="Order_id_holder">
        <div className="order_id">
          <div className="img_id_holder">
            {!isReturnPage && (
              <div>
                <div className="img_holder">
                  <img
                    className="Product_img"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/Image/Logo/Local-MandaiFinal-Logo.png"
                    }
                    alt="Product_img"
                  />
                </div>
              </div>
            )}

            {isReturnPage && (
              <div className="animation_holder">{/* <Return_Lottie /> */}</div>
            )}

            <div className="ms-3">
              <h2>{headingText}</h2>
              <p className="sub_text">{subText}</p>
              <div className="mt-3">
                <Cancel_Order_btn
                  btnText={"Invoice"}
                  onClick={() => handleDownloadInvoice(order?.invoice)}
                />
              </div>
            </div>
          </div>
          <p>{formatCustomDate(order?.createdAt)}</p>
        </div>
      </section>
    </>
  );
}

export default Order_id_holder;
